//libs
import React,{Component} from 'react';
import {connect} from 'react-redux';
//components
import  SearchForm from '../UI_Elements/Forms/SearchForm';
import List from '../UI_Elements/List';
//cnfings and helpers
import {getGroups} from '../../actions/stations';
import {setFalse} from '../../actions/refresh';
import {isAdmin} from '../../helpers';

class   ListGroups extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: [],
            search: ''
        }
        if (isAdmin()){
            props.getGroups();
        }
        this.filterList = this.filterList.bind(this)
    }


    filterList(e,v) {
        if (typeof(v)!=="undefined"){
            this.setState({
                search: v.substr(0, 20)
            })
        }
    }

    getFiltredStations(keyword){

        let stationsToReturn = [];
        if (typeof(this.props.groups)==="undefined"){
            return stationsToReturn;
        }
        if (keyword.length===0){
            return this.props.groups;
        }

        let s,u,station = null;
        for (s in this.props.groups){
            if(this.props.groups[s].name.toLowerCase().indexOf(keyword)>-1){
              stationsToReturn.push(this.props.groups[s]);
            } else {
                for(u in this.props.groups[s].users){
                    station = this.props.groups[s];
                  if ( station.users[u].firstname.toLowerCase().indexOf(keyword)>-1 ||
                    station.users[u].lastname.toLowerCase().indexOf(keyword)>-1 ||
                    station.users[u].userName.toLowerCase().indexOf(keyword)>-1) {
                    station.selected=true;
                    stationsToReturn.push(station);
                  }
                }
            }
        }

        return stationsToReturn;
    }

    render() {
        let filteredStations = this.getFiltredStations(this.state.search.toLowerCase());
        return (
            <div>
                <SearchForm
                    onClick={(event,value)=>this.filterList(event,value)}
                    value={this.state.search}
                />

                <div className='box list-groups'>
                    {/* <div className='select-all'>Välj alla</div> */}
                    <List stations={filteredStations} />
                </div>
            </div>
        );
    }
}

/**
 * Map state to properties
 */
const mapStateToPropsForListGroups = (state) => {
    return {
        refresh: state.refresh,
        groups: state.stations.groups
    };
};

/**
 * Map actions to properties
 */
const mapDispatchToPropsForListGroups = (dispatch) => {
    return {
        setFalse: (key) => dispatch(setFalse(key)),
        getGroups: ()=>dispatch(getGroups())
    };
};

/**
 * List groups
 */
export default connect(mapStateToPropsForListGroups, mapDispatchToPropsForListGroups)(ListGroups);


// WEBPACK FOOTER //
// ./src/components/UI_Elements/ListGroups.js